var _path, _circle, _path2, _path3, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGistology(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2822 6.18652C18.0568 5.59844 19.614 5.59388 20.8037 6.24023C23.8285 7.88362 26.1586 10.9655 26.9541 14.4209C27.7437 17.8511 27.0222 21.6415 23.9521 24.7803C20.9994 27.799 16.2574 27.7842 12.0674 26.168C9.99504 25.3686 8.13491 24.2013 6.80566 22.9121C5.45774 21.6048 4.74994 20.2678 4.75 19.1299C4.75015 17.7311 5.38141 16.0304 6.50293 14.2725C7.61547 12.5287 9.16674 10.7985 10.8984 9.35352C12.633 7.90614 14.5163 6.77181 16.2822 6.18652Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 20,
    r: 3.25,
    stroke: "black",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3419 13.7847C18.9902 13.6102 20.6405 14.0976 21.9295 15.1398",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5856 13.5858C12.8308 12.3405 14.4117 11.4847 16.1352 11.1227C17.8586 10.7607 19.6502 10.9082 21.2913 11.5472",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 20,
    r: 1,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGistology);
export default __webpack_public_path__ + "static/media/Gistology.d24cca01354210d8900d0efdb1d5266a.svg";
export { ForwardRef as ReactComponent };